module.exports = "<div gw-loader=\"accountDetailsPromise\">\r\n    <div gw-claim-summary\r\n         account=\"accountInfo\">\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/account/claims.html
// module id = 780
// module chunks = 0